import { brandSelectors as selector } from "../Selectors/index";
import Service from "../../Service/Item-master/itemBrand.service";
import { openSnackbar } from "./snackbarActions";

export const getBrand = () => {
  return {
    type: selector.GET,
  };
};

export const getBrandSuccess = (payload) => {
  return {
    type: selector.GET_SUCCESS,
    payload: payload,
  };
};

export const fetchBrand = () => {
  return async (dispatch) => {
    dispatch(getBrand());
    try {
      const res = await Service.getAll();
      dispatch(getBrandSuccess(res));
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };
};
